import CourseOfferAnnouncementsContainer from './CourseOfferAnnouncementsContainer';
import SingleCourseOfferAnnouncementContainer from './SingleCourseOfferAnnouncementContainer';

export { SingleCourseOfferAnnouncementContainer };
export default CourseOfferAnnouncementsContainer;
